import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Cached as CachedIcon } from '@mui/icons-material';
import CacheUsageDialog from './CacheUsageDialog';
import { getMessageCacheUsage, messageHasCacheUsage } from '../utils/cacheUsageUtils';

export default function CacheUsageIndicator({ message, origin = 'client' }) {
  const [open, setOpen] = useState(false);
  const cacheUsage = getMessageCacheUsage(message);

  if (!messageHasCacheUsage(message) || !cacheUsage) {
    return null;
  }

  return (
    <>
      <Tooltip title="View cache usage" arrow placement="top">
        <IconButton
          size="small"
          aria-label="View cache usage"
          onClick={(event) => {
            event.stopPropagation();
            setOpen(true);
          }}
          sx={{ p: 0.25, ml: 0.25 }}
        >
          <CachedIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
        </IconButton>
      </Tooltip>
      <CacheUsageDialog
        open={open}
        onClose={() => setOpen(false)}
        cacheUsage={cacheUsage}
        origin={origin}
      />
    </>
  );
}
